var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 27.8333C25.0573 27.8333 29.1666 23.724 29.1666 18.6667C29.1666 13.6093 25.0573 9.5 19.9999 9.5C14.9425 9.5 10.8333 13.6093 10.8333 18.6667C10.8333 23.724 14.9425 27.8333 19.9999 27.8333ZM19.9999 17.8333C20.4575 17.8333 20.8333 18.209 20.8333 18.6667C20.8333 19.1243 20.4575 19.5 19.9999 19.5C19.5423 19.5 19.1666 19.1243 19.1666 18.6667C19.1666 18.209 19.5423 17.8333 19.9999 17.8333Z",
    fill: "#ED5B75",
    stroke: "#ED5B75",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0333 36.3567C19.3154 36.5581 19.6534 36.6664 20 36.6664C20.3466 36.6664 20.6846 36.5581 20.9667 36.3567C21.4733 35.9983 33.3816 27.4 33.3333 16.6667C33.3333 9.315 27.3516 3.33334 20 3.33334C12.6483 3.33334 6.66665 9.315 6.66665 16.6583C6.61832 27.4 18.5267 35.9983 19.0333 36.3567ZM20 6.66667C25.515 6.66667 30 11.1517 30 16.675C30.035 24.0717 22.6866 30.7133 20 32.8917C17.315 30.7117 9.96498 24.0683 9.99998 16.6667C9.99998 11.1517 14.485 6.66667 20 6.66667Z",
    fill: "#ED5B75",
    stroke: "#ED5B75",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.f573ca4f7c106cc81de791e20041a660.svg";
export { ForwardRef as ReactComponent };